module.exports = __webpack_public_path__ + "static/media/car1.b1648414.gif";